import React from 'react'
import { ForgotPasswordForm } from '../components/Auth/ForgotPasswordForm';
import loginBG from '../assets/loginscreen-bg.jpg';
import { StyledMain, StyledSection } from './styles';
const ForgotPassword = () => {
  return (
    <>
      <StyledSection bgImage={loginBG} className='tma_app_content'>
        <StyledMain>
          <ForgotPasswordForm />
        </StyledMain>
      </StyledSection>
    </>
  )
}

export {ForgotPassword}